import { Component, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { map, Observable } from 'rxjs';

import { ProfilesService } from '@app/core/profiles';

@Component({
  selector: 'app-profile-select',
  templateUrl: './profile-select.component.html',
  styleUrls: ['./profile-select.component.css'],
})
export class ProfileSelectComponent implements ControlValueAccessor {
  public selectedProfiles: any[];
  public profiles$: Observable<Array<{ label: string; value: string }>>;

  public isDisabled: boolean;

  private onChange: (val: any) => any;
  private onTouch: () => any;

  constructor(
    @Self()
    @Optional()
    public control: NgControl,
    private profileService: ProfilesService
  ) {
    this.control && (this.control.valueAccessor = this);
    // map and order by label
    this.profiles$ = this.profileService
      .getList()
      .pipe(
        map((profiles) => {
          return profiles.map((profile) => {
            return {
              label: `${profile.application?.description || ''}: (${
                profile.title
              })`,
              value: profile.key,
            };
          });
        })
      )
      .pipe(
        map((profiles) => {
          return profiles.sort((a, b) => {
            return a.label.localeCompare(b.label);
          });
        })
      );
    this.profiles$.subscribe((profiles) => {
      console.log({ profiles, selected: this.selectedProfiles });
      // remove selected profiles that are not in the list
      this.selectedProfiles = this.selectedProfiles?.filter((profile) =>
        profiles.some((p) => p.value === profile)
      );
      // value is changed
      if (this.onChange) {
        this.onChange(this.selectedProfiles.join(','));
      }
    });
  }

  public get isInvalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get shouldShowError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;
    return this.isInvalid ? dirty || touched : false;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public writeValue(input: any): void {
    if (input) {
      input = input.split(',');
      input.forEach((i) => i.trim());
    } else {
      input = [];
    }

    this.selectedProfiles = input;
  }

  public selectedProfilesChanged(): void {
    this.onChange(this.selectedProfiles.join(','));
    this.onTouch();
  }
}
